module.exports = __webpack_public_path__ + "static/media/alert.9931755a.svg";